import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const FAQS = [
  { q: "How often should I get my bins cleaned?", a: "Most homeowners love our Monthly Renew plan — a fresh clean every 4 weeks keeps odor and bacteria away year-round. If you produce less waste, Quarterly (every 12 weeks) is a great fit." },
  { q: "Is this really a subscription?", a: "Yes — and we're upfront about it. Monthly and Quarterly plans save your card and automatically rebill on schedule so you never have to think about it. The One-Time Deep Clean has no commitment at all." },
  { q: "Can I cancel or pause?", a: "Absolutely. After your plan minimum (3 visits for Monthly, 2 for Quarterly), you can pause or cancel anytime through your secure Stripe customer portal — visit the Manage page and enter your email." },
  { q: "What is the Founding Customer Special?", a: "Early Monthly Renew customers get their first 3 visits at $29.99 instead of $34.99. It's applied automatically as a discount at checkout — no codes needed." },
  { q: "What if I have more than one bin?", a: "No problem. Each extra bin adds $10 per visit on recurring plans, or $15 on a One-Time Deep Clean. Just set the number of bins when you book." },
  { q: "How do time slots work?", a: "You can book any available day (except Sunday), 10am to 8pm, in 2-hour windows. Each slot has limited capacity so we never overbook — if a slot is full, it simply won't be selectable." },
  { q: "Which day should I choose?", a: "Your cleaning day is the same day as your visit — we recommend scheduling it on your trash pickup day so your bins are empty when we arrive. You're free to pick any available day, but please note we do NOT clean bins that still have trash bags inside." },
  { q: "What if I'm outside your service area?", a: "Enter your ZIP when booking. If you're outside our current area, we'll capture your info and personally follow up as we expand — no payment is taken." },
  { q: "How will I know my booking is confirmed?", a: "You'll get an instant confirmation email with your receipt and first-visit details, plus a reminder before we arrive." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="pb-24">
      <div className="mx-auto max-w-3xl px-5 pt-20 text-center lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary">FAQ</p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tighter md:text-5xl">
          Questions, answered
        </h1>
        <p className="mt-5 text-lg text-muted-foreground">
          Everything you need to know about clean bins and how billing works.
        </p>
      </div>
      <div className="mx-auto mt-12 max-w-3xl px-5 lg:px-8">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-border bg-card px-6"
            >
              <AccordionTrigger className="text-left font-heading text-lg font-semibold hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-12 rounded-2xl border border-border bg-accent px-8 py-8 text-center">
          <p className="font-heading text-lg font-bold text-accent-foreground">Still have a question?</p>
          <Link to="/contact" className="mt-3 inline-flex rounded-xl bg-primary px-6 py-3 font-bold text-primary-foreground transition-all hover:-translate-y-0.5 hover:brightness-110">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
